import React from 'react';
import moment from "moment";

import { P2Bold } from '../../../../../Common/DesignSystem/Text';
import colours from '../../../../../Common/DesignSystem/Colours';
import Icon from '../../../../../Common/DesignSystem/Icons/Icon';
import MessageCard from '../../../../../Common/DesignSystem/MessageCard';

export const VehicleIconsCard = ({ vehicleForm, vehicleOemDetails }) => (
	<div className="overlay_header_bordered" style={{flexGrow: 0, marginTop: 16}}>
		<div className="profile-info-container">
			<div style={{flexDirection: 'column', flex: 1, display: 'flex', width: '100%'}}>
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<P2Bold style={{padding: '8px 0px', color: colours.primary.grey01}}>
						End User Icons
					</P2Bold>
					{/* <div data-tooltip data-multiline data-tip="These icons appear on<br/>the User booking screen.<br/>They are automatically<br/>selected based on the<br/>Specifications and Vehicle<br/>Settings." style={{marginBottom: 4, marginLeft: 4}}>
						<Icon name="Info" size={20} /> 
					</div> */}
				</div>
				<div style={{margin: '8px 0'}}>
					<MessageCard variant="info" message="These icons appear on the User booking screen. They are automatically selected based on the Specifications and Vehicle Settings."/>
				</div>
				<div className="ds-eu-icon-outer-container">
					<div className={"ds-eu-icon-inner-container" + (vehicleOemDetails.drive_train_opt[vehicleForm.drive_train] == 'AWD' ? '' : ' disabled')}>
						<Icon name="EuAwd" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>AWD</P2Bold>
					</div>
					<div className={"ds-eu-icon-inner-container" + (vehicleOemDetails.engine_opt[vehicleForm.engine] == 'Electric' ? '' : ' disabled')} style={{marginLeft: 24}}>
						<Icon name="EuElectric" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Electric</P2Bold>
					</div>
				</div>
				<div className="ds-eu-icon-outer-container">
					<div className={"ds-eu-icon-inner-container" + (vehicleOemDetails.engine_opt[vehicleForm.engine] == 'Hybrid' ? '' : ' disabled')}>
						<Icon name="EuHybrid" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Hybrid</P2Bold>
					</div>
					<div className={"ds-eu-icon-inner-container" + (moment(vehicleForm.available_date, 'MM-DD-YYYY').isValid() && moment(vehicleForm.available_date, 'MM-DD-YYYY').add(7, 'days').isSameOrAfter(moment()) ? '' : ' disabled')} style={{marginLeft: 24}}>
						<Icon name="EuJustAdded" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Just Added</P2Bold>
					</div>
				</div>
				<div className="ds-eu-icon-outer-container">
					<div className={"ds-eu-icon-inner-container" + (moment(vehicleForm.retire_date, 'MM-DD-YYYY').isValid() && moment(vehicleForm.retire_date, 'MM-DD-YYYY').isSameOrBefore(moment().add(7, 'days')) ? '' : ' disabled')}>
						<Icon name="EuLeavingSoon" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Leaving Soon</P2Bold>
					</div>
					<div className={"ds-eu-icon-inner-container" + (vehicleForm.is_new_model ? '' : ' disabled')} style={{marginLeft: 24}}>
						<Icon name="EuNewModel" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>New Model</P2Bold>
					</div>
				</div>
				<div className="ds-eu-icon-outer-container">
					<div className={"ds-eu-icon-inner-container" + (vehicleOemDetails.engine_opt[vehicleForm.engine] == 'Plug In Hybrid' ? '' : ' disabled')}>
						<Icon name="EuPluginHybrid" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Plug-in Hybrid</P2Bold>
					</div>
					<div className={"ds-eu-icon-inner-container" + (vehicleForm.is_prototype ? '' : ' disabled')} style={{marginLeft: 24}}>
						<Icon name="EuPrototype" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Prototype</P2Bold>
					</div>
				</div>
				<div className="ds-eu-icon-outer-container">
					<div className={"ds-eu-icon-inner-container" + (vehicleForm.is_redesign ? '' : ' disabled')}>
						<Icon name="EuRedesign" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Redesign</P2Bold>
					</div>
					<div className={"ds-eu-icon-inner-container" + (vehicleOemDetails.tires_opt[vehicleForm.tires] == 'Winter' ? '' : ' disabled')} style={{marginLeft: 24}}>
						<Icon name="EuSnowTires" size={24}/>
						<P2Bold style={{marginLeft: 8, color: colours.primary.grey01}}>Snow Tires</P2Bold>
					</div>
				</div>
			</div>
		</div>
	</div>
);